import React from "react";
import { ReactComponent as FacebookIcon } from "../../assets/Icons/facebook.svg";
import { ReactComponent as InstagramIcon } from "../../assets/Icons/instagram.svg";
import { ReactComponent as TwitterIcon } from "../../assets/Icons/twitter.svg";
import { ReactComponent as LinkedInIcon } from "../../assets/Icons/linkedIn.svg";
import { ReactComponent as YoutubeIcon } from "../../assets/Icons/youtube.svg";
import { ReactComponent as TikTokIcon } from "../../assets/Icons/tiktok.svg";
import { ReactComponent as AppStore } from "../../assets/Icons/appstore.svg";
import { ReactComponent as PlayStore } from "../../assets/Icons/playstore.svg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Translate from "../MultiLanguage/Translate";

const Footer = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
   const pubid = projectInfo?.projectConfig?.pubid;
  const navigate = useNavigate();

  const linkHandler = (data) => {
    if (data?.seo_url) {
      navigate(data?.seo_url);
    } else if (data?.link) {
      window.open(data?.link);
    }
  };

  return (
    <div className="footerContainer">
      <div className="wrapper">
        <div className="topContainer">
          <div className="left">
            <div className="logoContainer">
              <img src={projectInfo?.projectConfig?.config?.LOGO} alt="Logo" />
            </div>
          </div>
          <div className="right">
            <ul className="social">
              {projectInfo?.projectConfig?.config?.FACEBOOK && (
                <li onClick={() => window.open(projectInfo?.projectConfig?.config?.FACEBOOK, "blank")}>
                  <FacebookIcon />
                </li>
              )}

              {projectInfo?.projectConfig?.config?.INSTAGRAM && (
                <li onClick={() => window.open(projectInfo?.projectConfig?.config?.INSTAGRAM, "blank")}>
                  <InstagramIcon />
                </li>
              )}
              {projectInfo?.projectConfig?.config?.TWITTER && (
                <li onClick={() => window.open(projectInfo?.projectConfig?.config?.TWITTER, "blank")}>
                  <TwitterIcon />
                </li>
              )}
              {projectInfo?.projectConfig?.config?.LINKEDIN && (
                <li onClick={() => window.open(projectInfo?.projectConfig?.config?.LINKEDIN, "blank")}>
                  <LinkedInIcon />
                </li>
              )}
              {projectInfo?.projectConfig?.config?.YOUTUBE && (
                <li onClick={() => window.open(projectInfo?.projectConfig?.config?.YOUTUBE, "blank")}>
                  <YoutubeIcon />
                </li>
              )}
              {projectInfo?.projectConfig?.config?.TIKTOK && (
                <li onClick={() => window.open(projectInfo?.projectConfig?.config?.TIKTOK, "blank")}>
                  <TikTokIcon />
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="centerContainer">
          <div className="informationContainer">
            {projectInfo?.projectConfig?.config?.WEBSITE_FOOTERS?.map((data, index) => {
              // if (pubid === 50141 && index === 0) {
              //   return (
              //     <div className="items first-footer-col" key={index}>
              //       <h6 className="heading"><Translate textKey={data.title} /></h6>
              //       <ul>
              //         {data?.items?.map((item, idx) => (
              //           <li key={idx}>
              //             <span onClick={() => linkHandler(item)}><Translate textKey={item.title} /></span>
              //           </li>
              //         ))}
              //       </ul>
              //       <div className="static-footer-info">
              //         <h6 className="heading">COMPANY</h6>
              //         <ul>
              //           <li><span>Our Story</span></li>
              //           <li><span>Press Releases and News</span></li>
              //           <li><span>Film Festivals</span></li>
              //           <li><span>Film Competition</span></li>
              //         </ul>
              //       </div>
              //     </div>
              //   );
              // }
              return (
                <div className="items" key={index}>
                  <h6 className="heading"><Translate textKey={data.title} /></h6>
                  <ul>
                    {data?.items?.map((item, idx) => (
                      <li key={idx}>
                        <span onClick={() => linkHandler(item)}><Translate textKey={item.title} /></span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="bottomContainer">
        <div className="stores">
          {projectInfo?.projectConfig?.config?.IOS_APP_STORE_URL && (
            <AppStore onClick={() => window.open(projectInfo?.projectConfig?.config?.IOS_APP_STORE_URL, "blank")} />
          )}
          {projectInfo?.projectConfig?.config?.ANDROID_PLAY_STORE_URL && (
            <PlayStore
              onClick={() => window.open(projectInfo?.projectConfig?.config?.ANDROID_PLAY_STORE_URL, "blank")}
            />
          )}
        </div>
        <p>{projectInfo?.projectConfig?.config?.COPYRIGHT_TEXT}</p>
        <p><Translate textKey={'all_rights_reserved'} /></p>
        {projectInfo?.projectConfig?.config?.FOOTER_PAYMENTS_REQUIRED === "true" && (
          <div className="typeOfPayments">
            <i className="fa fa-2x fa-cc-discover"></i>
            <i className="fa-brands fa-2x fa-cc-mastercard"></i>
            <i className="fa fa-2x fa-cc-paypal"></i>
            <i className="fa fa-2x fa-cc-visa"></i>
          </div>
        )}
      </div>
    </div>
  );
};

export default Footer;
